/* @jsx h */
import { h } from 'preact';

// SVG icon definitions:

const icons = {
		'arrow-right': {
			paths: [
				'M12.5,21A.75.75,0,0,1,12,19.73L16.46,15,12,10.27a.75.75,0,1,1,1.09-1l5,5.25a.75.75,0,0,1,0,1l-5,5.25A.75.75,0,0,1,12.5,21Z'
			]
		},
		'arrow-left': {
			paths: [
				'M17.5,21a.75.75,0,0,1-.54-.23l-5-5.25a.75.75,0,0,1,0-1l5-5.25a.75.75,0,1,1,1.09,1L13.54,15,18,19.73A.75.75,0,0,1,17.5,21Z'
			]
		},
		'arrow-down': {
			paths: [
				'M15,18.25a.75.75,0,0,1-.52-.21L9.23,13a.75.75,0,0,1,1-1.09L15,16.46,19.73,12a.75.75,0,1,1,1,1.09l-5.25,5A.75.75,0,0,1,15,18.25Z'
			],
			viewbox: '0 0 30 30'
		},
		'arrow-up': {
			paths: [
				'M19.25,18.25a.75.75,0,0,1-.52-.21L14,13.54,9.27,18a.75.75,0,1,1-1-1.09l5.25-5a.75.75,0,0,1,1,0l5.25,5a.75.75,0,0,1-.52,1.29Z'
			],
			viewbox: '0 0 30 30'
		},
		'menu': {
			paths: [
				'M10 13.193h20c.553 0 1-.447 1-1s-.447-1-1-1H10c-.553 0-1 .447-1 1s.447 1 1 1zm20 13.614H10c-.553 0-1 .447-1 1s.447 1 1 1h20c.553 0 1-.447 1-1s-.447-1-1-1zm0-7.824H10c-.553 0-1 .447-1 1s.447 1 1 1h20c.553 0 1-.447 1-1s-.447-1-1-1z'
			],
			fill: '#9b9b9b',
			viewbox: '0 0 40 40'
		},
		'close': {
			paths: [
				'M29.707 11.707l-1.414-1.414L20 18.586l-8.293-8.293-1.414 1.414L18.586 20l-8.293 8.293 1.414 1.414L20 21.414l8.293 8.293 1.414-1.414L21.414 20'
			],
			viewbox: '0 0 40 40'
		},
		'basket': {
			paths: [
				'M24.578 14.917l-1.848-.102-.73 13.2 1.847.102.73-13.2zm0-3.908v-.578c0-1.3-1.054-2.356-2.35-2.356H17.77c-1.297 0-2.352 1.057-2.352 2.356v.577H10.5v1.85h1.157l1.002 16.41c.095 1.514 1.258 2.655 2.704 2.655h9.272c1.425 0 2.588-1.136 2.706-2.657l1.002-16.41H29.5v-1.85h-4.92zm-7.307-.578c0-.28.227-.507.503-.507h4.455c.276 0 .502.228.502.507v.577h-5.46v-.578zm8.227 18.707c-.035.45-.32.936-.86.936h-9.273c-.525 0-.83-.465-.86-.92l-.994-16.297h12.98l-.993 16.28zm-4.572-14.274h-1.85v13.2h1.85v-13.2zM18 28.016l-.73-13.2-1.848.102.73 13.2 1.85-.102z'
			]
		},
		'info': {
			paths: [
				'M20 23.49c-.53 0-.957.43-.957.957 0 .53.428.957.957.957s.957-.428.957-.957c0-.53-.428-.957-.957-.957zM20 9C13.925 9 9 13.925 9 20s4.925 11 11 11 11-4.925 11-11S26.075 9 20 9zm0 20c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zm0-14.737c-.553 0-1 .447-1 1v5.36c0 .552.447 1 1 1s1-.448 1-1v-5.36c0-.553-.447-1-1-1z'
			],
			viewbox: '0 0 40 40'
		},
		'info-hover': {
			paths: [
				'M20 9C13.925 9 9 13.925 9 20s4.925 11 11 11 11-4.925 11-11S26.075 9 20 9zm0 16.404c-.53 0-.957-.428-.957-.957 0-.53.428-.957.957-.957.53 0 .957.43.957.957 0 .528-.428.957-.957.957zm1-4.782c0 .553-.447 1-1 1s-1-.447-1-1v-5.36c0-.552.447-1 1-1s1 .448 1 1v5.36z'
			],
			viewbox: '0 0 40 40'
		},
		'checkcheck': {
			paths: [
				'M16.65 29.23l-9.43-9.42a1.1 1.1 0 1 1 1.56-1.56l7.87 7.87 14.57-14.57a1.1 1.1 0 0 1 1.56 1.56z'
			],
			viewbox: '0 0 40 40'
		},
		'basket-empty': {
			paths: [
				'M21.28,0a7.78,7.78,0,0,0-7.7,6.77H7.52L6.18,1.43a1,1,0,0,0-1-.76H1a1,1,0,0,0,0,2H4.43l4,16.1a1,1,0,0,0,1,.76H22.91a1,1,0,0,0,1-.73L25,14.56A7.77,7.77,0,0,0,21.28,0Zm.87,17.52H10.21L8,8.77h5.57a7.74,7.74,0,0,0,9.16,6.63Zm-.87-4a5.77,5.77,0,1,1,5.77-5.77A5.78,5.78,0,0,1,21.28,13.54Z',
				'M24.53,4.52a1,1,0,0,0-1.41,0L21.28,6.35,19.45,4.52A1,1,0,0,0,18,5.94l1.83,1.83L18,9.6A1,1,0,1,0,19.45,11l1.83-1.83L23.11,11A1,1,0,0,0,24.53,9.6L22.7,7.77l1.83-1.83A1,1,0,0,0,24.53,4.52Z'
			],
			primitives: [
				<circle key="c1" cx="10.27" cy="21.89" r="1.69"/>,
				<circle key="c2" cx="21.22" cy="21.89" r="1.69"/>
			],
			viewbox: '0 0 29.05 23.58'
		},
		'search': {
			paths: [
				'M24.395 22.98c1.256-1.563 2.012-3.545 2.012-5.703 0-5.035-4.096-9.13-9.13-9.13-5.035 0-9.13 4.096-9.13 9.13s4.095 9.13 9.13 9.13c2.158 0 4.14-.755 5.704-2.012l7.46 7.458 1.413-1.414-7.458-7.46zm-7.118 1.428c-3.932 0-7.13-3.2-7.13-7.13 0-3.933 3.198-7.13 7.13-7.13s7.13 3.198 7.13 7.13c0 3.93-3.198 7.13-7.13 7.13z'
			],
			viewbox: '0 0 40 40'
		},
		'delete': {
			paths: [
				'M24.578 14.917l-1.848-.102-.73 13.2 1.847.102.73-13.2zm0-3.908v-.578c0-1.3-1.054-2.356-2.35-2.356H17.77c-1.297 0-2.352 1.057-2.352 2.356v.577H10.5v1.85h1.157l1.002 16.41c.095 1.514 1.258 2.655 2.704 2.655h9.272c1.425 0 2.588-1.136 2.706-2.657l1.002-16.41H29.5v-1.85h-4.92zm-7.307-.578c0-.28.227-.507.503-.507h4.455c.276 0 .502.228.502.507v.577h-5.46v-.578zm8.227 18.707c-.035.45-.32.936-.86.936h-9.273c-.525 0-.83-.465-.86-.92l-.994-16.297h12.98l-.993 16.28zm-4.572-14.274h-1.85v13.2h1.85v-13.2zM18 28.016l-.73-13.2-1.848.102.73 13.2 1.85-.102z'
			],
			viewbox: '0 0 40 40'
		},
		'edit': {
			paths: [
				'M30.31 9.69c-1.79-1.78-4.14-1.93-5.73-.34L10 23.93a.88.88 0 0 0-.23.42l-1.5 6.32a.87.87 0 0 0 .85 1.08h.2l6.32-1.49a.88.88 0 0 0 .42-.23l14.59-14.61c1.58-1.58 1.44-3.94-.34-5.73zm-20 20l.8-3.41 2.6 2.6zm5.14-1.55l-3.6-3.59 10.89-10.89 3.59 3.59zM27.57 16L24 12.43l.88-.88 3.59 3.59zm2.08-2.15l-3.53-3.53a2.27 2.27 0 0 1 2.95.59 2.27 2.27 0 0 1 .59 2.97z'
			],
			viewbox: '0 0 40 40'
		},
		'list': {
			paths: [
				'M4.12 25.88h5.75v-5.75H4.12v5.75zm1.75-4h2.25v2.25H5.87v-2.25zm6.25-17.75v5.75h13.75V4.13H12.12zm12 4H13.87V5.88h10.25v2.25zm-12 9.75h13.75v-5.76H12.12v5.76zm1.75-4h10.25v2.25H13.87v-2.25zm-9.75 4h5.75v-5.76H4.12v5.76zm1.75-4h2.25v2.25H5.87v-2.25zm-1.75-4h5.75V4.13H4.12v5.75zm1.75-4h2.25v2.25H5.87V5.88zm6.25 20h13.75v-5.75H12.12v5.75zm1.75-4h10.25v2.25H13.87v-2.25z'
			],
			viewbox: '0 0 30 30'
		},
		'filter': {
			paths: [
				'M13.637 25v-9.727L5 5h21l-8.297 10.263v5.795L13.637 25zM8.57 6.627l6.793 8.063v6.302l.67-.649V14.7l6.511-8.072H8.571z'
			],
			viewbox: '0 0 30 30'
		},
		'map': {
			paths: [
				'M21.58 13.44A.88.88 0 0 0 21 15.1l3.6 1.2v8l-4.55-1.52V17.1a.88.88 0 0 0-1.75 0v5.59l-6.65 1.69v-8l.28-.07a23 23 0 0 0 2.43 2.85l.6.58.6-.58c.21-.2 5.17-5 5.17-9.73a5.775 5.775 0 0 0-11.55 0 10.85 10.85 0 0 0 1.72 5.33h-.11l-7.21-2.4V24l7.14 2.42 8.4-2.13 7.21 2.4V15l-4.75-1.56zM15 5.38a4 4 0 0 1 4 4c0 3.09-2.77 6.47-4 7.84-1.26-1.37-4-4.74-4-7.84a4 4 0 0 1 4-4zm-9.62 9.41l4.55 1.52v8l-4.55-1.54v-7.98z',
				'M17.27 9.4A2.27 2.27 0 1 0 15 11.67a2.28 2.28 0 0 0 2.27-2.27zm-2.8 0a.52.52 0 1 1 .52.53.53.53 0 0 1-.52-.53z'
			],
			viewbox: '0 0 30 30'
		}
	},
	Icon = ({ id, fill, viewbox }) => (
		<svg viewBox={viewbox || icons[id].viewbox} class={`icon_${id}`}>
			{icons[id].primitives}
			{icons[id].paths.map((path, i) => <path d={path} fill={fill || icons[id].fill} key={i} />)}
		</svg>
	);

export default Icon;
